import { keyBy } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { ProjectLayoutModel } from '@paragon/contract-library';

import { getProjectLayoutModels } from './getProjectLayoutModels';

export const getProjectLayoutModelsByGuid = createSelector(
  getProjectLayoutModels,

  (projectLayoutModels): { [projectGuid: string]: ProjectLayoutModel } =>
    keyBy(projectLayoutModels, (projectLayoutModel) => projectLayoutModel.guid),
);
